module.exports = __webpack_public_path__ + "static/media/0.beginning.7d268241.mp4";